module.exports = __webpack_public_path__ + "media/images/mobile/home/banner4-a411e8ed2af3e2692491be42166acf22.jpg";